// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"B5-z"};